import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@angular/cdk/layout';
import { ReactiveFormsModule } from '@angular/forms';
import { GraphQLModule } from '../../graphql.module';

import { MatFieldComponent } from './components/mat-field/mat-field.component';
import { ApiService } from './services/api/api.service';
import { QuestionnaireService } from './services/questionnaire/questionnaire.service';
import { DrawerComponent } from './components/drawer/drawer.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ProgramStatusService } from '@ebb-v2/ebb-integration';

@NgModule({
  declarations: [
    MatFieldComponent,
    DrawerComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    LayoutModule,
    MatCardModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatSidenavModule,
    GraphQLModule,
    MatDialogModule
  ],
  exports: [
    LayoutModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatListModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonToggleModule,
    MatFieldComponent,
    DrawerComponent,
    MatSidenavModule,
    GraphQLModule,
    MatDialogModule
  ],
  providers: [
    ApiService,
    QuestionnaireService,
    ProgramStatusService
  ]
})
export class SharedModule { }
